import styles from './UtilLink.scss';

import cx from 'classnames';
import { Entry } from 'contentful';
import React from 'react';

import { HasMaterialIcon, Link } from 'src/api/contentful/contentTypes.cloverdotcom';
import { ContentLink, IContentLinkProps } from 'src/components/ContentLink/ContentLink';
import { MaterialIcon } from 'src/components/MaterialIcon/MaterialIcon';
import { getField } from 'src/utils/EntryUtil';

export interface IUtilLink extends IContentLinkProps {
  entry?: Entry<Link>;
  hidden?: boolean;
  mobile?: boolean;
  children?: never;
}

export const UtilLink: React.FC<IUtilLink> = ({ entry, hidden, mobile, className, ...props }) => {
  const materialIcon = getField(entry as Entry<HasMaterialIcon>, 'materialIcon');
  return (
    <ContentLink
      tabIndex={hidden ? -1 : undefined}
      entry={entry}
      hideTitle={!!materialIcon && mobile}
      className={cx(styles.utilLink, className)}
      {...props}
    >
      {!!materialIcon && mobile && <MaterialIcon icon={materialIcon} />}
    </ContentLink>
  );
};
